import { PureConnect, React } from '../../react';
import { ProgressBar } from '../../react-toolbox-redesign/progressbar';

import { messageSelector, statusSelector, visibleSelector } from './selectors';

import STATUS_HIDE from './actions/HIDE';

export type Status = 'success' | 'error' | 'pending';

export default PureConnect('StatusArea')(
    (state) => ({
        message: messageSelector(state),
        status: statusSelector(state),
        visible: visibleSelector(state),
    }),
    (dispatch) => ({
        close: () => dispatch(STATUS_HIDE({ })),
    }),
    ({ message, status, visible, close }) => (
            visible ?
            <ProgressBar caption={message} status={status}></ProgressBar> : null
    ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/statusDialog/dialog.tsx